export const SUBSCRIPTION_INTERVAL = {
	MONTH: 'MONTH',
	YEAR: 'YEAR',
} as const;

export type SubscriptionInterval =
	(typeof SUBSCRIPTION_INTERVAL)[keyof typeof SUBSCRIPTION_INTERVAL];

export const SUBSCRIPTION_TERM = {
	ANNUAL: 'Annually',
	MONTHLY: 'Monthly',
} as const;

export type SubscriptionTerm =
	(typeof SUBSCRIPTION_TERM)[keyof typeof SUBSCRIPTION_TERM];

export function getSubscriptionTerm(
	interval: SubscriptionInterval,
): SubscriptionTerm {
	switch (interval) {
		case SUBSCRIPTION_INTERVAL.MONTH:
			return SUBSCRIPTION_TERM.MONTHLY;
		case SUBSCRIPTION_INTERVAL.YEAR:
			return SUBSCRIPTION_TERM.ANNUAL;
		default:
			throw new Error('Invalid subscription term');
	}
}

export function isValidSubscriptionInterval(
	interval: unknown,
): interval is SubscriptionInterval {
	const lowerCaseInterval = String(interval).toLowerCase();
	return (
		lowerCaseInterval === SUBSCRIPTION_INTERVAL.MONTH.toLowerCase() ||
		lowerCaseInterval === SUBSCRIPTION_INTERVAL.YEAR.toLowerCase()
	);
}

export function isValidSubscriptionTerm(
	term: unknown,
): term is SubscriptionTerm {
	const lowerCaseTerm = String(term).toLowerCase();
	return (
		lowerCaseTerm === SUBSCRIPTION_TERM.ANNUAL.toLowerCase() ||
		lowerCaseTerm === SUBSCRIPTION_TERM.MONTHLY.toLowerCase()
	);
}
